import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const independence: BlogMetaData = {
  title: '栗山監督から学ぶ、子どもの自立心の育むためには？モンテの考え方が大切です！',
  description:
    '子どもの自立心の育むと言われているモンテッソーリ教育。どのような関わり方が大切なのか、モンテ歴２０年のベテラン講師が解説！',
  thumbnailUrl: '/img/blog-independence-thumbnail.webp',
  filePath: buildBlogFilePath('independence'),
  category: BLOG_CATEGORY.INTRODUCTION,
};
